import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
const paymentKeys = {
    all: ['payments'],
    get: (filter, scope) => ['payments', 'list', filter, scope],
    stats: () => ['payments', 'stats'],
};
export const paymentOptions = {
    get: (filter, scope, options) => queryOptions({
        queryKey: paymentKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Payment);
            return repo.get(filter, scope);
        },
        enabled: options?.enabled,
        refetchInterval: options?.refetchInterval ? (query) => options.refetchInterval(query.state.data) : undefined,
    }),
    stats: () => queryOptions({
        queryKey: paymentKeys.stats(),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.Payment);
            return repo.getStats();
        },
    }),
    exportToCsv: () => ({
        mutationFn: async (filter) => {
            const repo = await resolveRepository(Domain.Payment);
            return repo.exportToCsv(filter);
        },
    }),
    exportToPdf: () => ({
        mutationFn: async (filter) => {
            const repo = await resolveRepository(Domain.Payment);
            return repo.exportToPdf(filter);
        },
    }),
};
